import { useLazyQuery } from "@apollo/client";
import { GetServerDateAndTimeWithoutToken } from "../queries/queries";
import {
  ServerDateTimeWithoutTokenData,
  ServerDateTimeWithoutTokenVars,
} from "../queries/types";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/context";

const useServerDateandTimeWithoutToken = () => {
  const [serverDate, setServerDate] = useState("");
  const { state } = useContext(AppContext);
  const [GetDate, { data, loading }] = useLazyQuery<
    ServerDateTimeWithoutTokenData,
    ServerDateTimeWithoutTokenVars
  >(GetServerDateAndTimeWithoutToken, {
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        GetDate({
          variables: {
            customer_id: state.customerId,
          },
        });
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [GetDate, state.customerId]);
  useEffect(() => {
    if (data && !loading) {
      setServerDate(data.GetServerDateAndTimeWithoutToken);
    }
  }, [data, loading]);
  return {
    serverDate,
    data,
    loading,
  };
};

export default useServerDateandTimeWithoutToken;
